<form (ngSubmit)="onSuccessAdd()" [formGroup]="form">
    <div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title translate>add_agrement</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-select-common
                    #list
                    (objectcontenu)="getobject($event)"
                    [code]="'UM04'"
                    [control]="getFormControl('licenseNm')"
                    [label]="'Classification de l\'agrément'"
                ></app-select-common>
            </div>
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-select-common
                        [code]="codefils?codefils:getFormControl('licenseCd').value.toString().substring(0,4)"
                        [control]="getFormControl('licenseCd')"
                        [label]="'Agrément'"
                ></app-select-common>
            </div>
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('licenseRegNo')"
                        [label]="'N° d\'enregistrement de(s) agrément(s)'"

                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('issuedYmd')"
                        [label]="'Date de l\'obtention'"
                        [max]="currentDate"

                ></app-select-date>
            </div>
            <div fxFlex.gt-sm="50" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('expirationYmd')"
                        [label]="'Date d\'expiration'"
                        [min]="currentDate"

                ></app-select-date>
            </div>
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('issuedInst')"
                        [label]="'Institution de délivrance'"

                ></app-text-field>
            </div>


        </div>


    </div>
    <div class="pc" fxLayoutAlign="end end" mat-dialog-actions>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button [disabled]="form.invalid" color="primary" mat-raised-button type="submit">
                {{ "submit" | translate }}
            </button>
        </div>
    </div>
</form>
